<template>
<div id="card-details">
    <div>
        <img id="img-pincipal" class="mb-2" :src="foto == '' ? this.semImagem : 'data:image/jpeg;base64,' +  foto">
    </div>
    <div id="info">
        <p class="text-center">INFORMAÇÕES</p>
    </div>
    <div class="card-details-body mt-2 ml-3">
        <p id="nameTower">{{selectedEnterprise.nome != null ? selectedEnterprise.nome : 'N/d'}}</p>
        <p class="label-details ">Cidade</p>
        <p class="result-details">{{selectedEnterprise.cidade.nome != null ? selectedEnterprise.cidade.nome : 'N/d'}}</p>
        <p class="label-details">Rua</p>
        <p class="result-details">{{selectedEnterprise.endereco != null ? selectedEnterprise.endereco : 'N/d'}}</p>
        <p class="label-details">Bairro</p>
        <p class="result-details">{{selectedEnterprise.bairro != null ? selectedEnterprise.bairro : 'N/d'}}</p>
        <p class="label-details">Cep</p>
        <p class="result-details">{{selectedEnterprise.cep != null ? selectedEnterprise.cep : 'N/d'}}</p>
        <p class="label-details">DT. última atualização</p>
        <p class="result-details">{{selectedEnterprise.dataVencimentoTabelaPrecoFormatada != null ? selectedEnterprise.dataVencimentoTabelaPrecoFormatada : 'N/d'}}</p>
        <p class="label-details">Formas de Pagamento</p>
        <p class="result-details">12 Opções</p>
    </div>
</div>
</template>

<script>
import panelPrice from './panelPrice.js'
export default panelPrice
</script>

<style scoped>
#card-details {
    width: 100%;
    height: 100%;
    border: 1px solid rgb(202, 202, 202);
    background-color: white;
    border-radius: 5px;
}

.text-center{
    font-size: 20px;
}
.label-details{
    font-size: 14px;
     color: #4F4C4D;
}

@media (min-width: 800px ) and (max-width: 1400px) {
  #nameTower{
      color: #5a5a5a;
      font-size: 17px;
      font-weight: 700;
      line-height: 30px;
      font-family: Segoe UI;
  }
}

@media (min-width: 1401px ){
  #nameTower{
    color: #5a5a5a;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
  }
}

#card-img{
  height: 250px;
}

#img-pincipal{
    height: 100%;
    width: 100%;
    object-fit: cover;
}

#info{
    height: 50px;
    width: 100%;
    font-size: 22px;
    background-color: #008148;
    padding-top: 15px;
    color: white;
}

.label-details{
    font-size: 13px;
    color: #666;
    font-weight: 700;
    margin-bottom: 0;
}
.result-details{
    font-size: 15px;
    color: #2a2a2a;
}
</style>



// WEBPACK FOOTER //
// src/views/private/realestate/pricetablemanagement/components/panelPrice/panelPrice.vue